// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-Instant":"Instant_cost-saving-Instant__upLB3"};